var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _line, _line2, _line3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "integrate",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1040.21 862.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-2, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        fill: none;\n      }\n\n      .cls-18 {\n        fill: #698996;\n      }\n\n      .cls-19, .cls-4 {\n        fill: #003153;\n      }\n\n      .cls-4 {\n        stroke: #000;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11, .cls-12 {\n        stroke-linecap: round;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: 2px;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-5, .cls-6, .cls-9, .cls-12, .cls-14 {\n        stroke: #003153;\n      }\n\n      .cls-5, .cls-2, .cls-8, .cls-15 {\n        stroke-width: 9px;\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-2, .cls-7, .cls-8, .cls-10, .cls-11, .cls-15 {\n        stroke: #06b6db;\n      }\n\n      .cls-7 {\n        stroke-width: 7px;\n      }\n\n      .cls-7, .cls-23 {\n        fill: #7b0d1e;\n      }\n\n      .cls-24 {\n        fill: #edeff1;\n      }\n\n      .cls-9 {\n        stroke-width: 6px;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-26 {\n        fill: #00534b;\n      }\n\n      .cls-10, .cls-11, .cls-13, .cls-14, .cls-16 {\n        stroke-width: 3px;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-12 {\n        stroke-width: 4px;\n      }\n\n      .cls-13 {\n        stroke: #9cafb5;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-16, .cls-17 {\n        stroke: #698996;\n      }\n\n      .cls-17 {\n        stroke-width: 5px;\n      }\n\n      .cls-29 {\n        fill: #eace02;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.83,
    y: 361.83,
    width: 321,
    height: 386
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 14.83,
    y: 72.83,
    width: 315,
    height: 230
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 832.83,
    y: 700.83,
    width: 195,
    height: 94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 603.83,
    y: 471.83,
    width: 189,
    height: 370
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 628.33,
    y: 116.83,
    width: 176.5,
    height: 22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 628.33,
    y: 84.83,
    width: 176.5,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.98,531.46c15.38-115.37,119.36-232.06,251.71-268.88,54.04-15.03,114.72-34.6,151.8-62.56,70.51-53.18,61.42-78.18,159.27-141.16,74.87-48.19,165.25-49.35,182.77-49.31,79.11.16,139.88,27.81,170,51.07,96.55,74.55-140.43,217.61-55.4,366.73,10.47,18.36,56.37,80.4,40.48,127.37-24.4,72.12-161.55,131.35-260.47,143.71-77.48,9.68-129.84,11.7-230.44,41.47-147.99,43.8-145.15,97.07-263.29,110.47-97.33,11.04-168.19-155.73-146.43-318.91Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lines-2",
    "data-name": "lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 590.83,
    y1: 233.33,
    x2: 467.79,
    y2: 233.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m603.83,664.83v-4.2c0-3.2-2.59-5.8-5.8-5.8h-62.93c-3.2,0-5.8-2.59-5.8-5.8v-142.65c0-3.31-2.69-6-6-6h-55.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 834.83,
    y1: 554.83,
    x2: 792.83,
    y2: 554.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 930.33,
    y1: 700.83,
    x2: 930.33,
    y2: 664.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m518.33,215.33l21.92,16.13c1.15.85,1.15,2.23,0,3.07l-21.92,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m399.5,536.96l21.92,16.13c1.15.85,1.15,2.23,0,3.07l-21.92,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m329.33,187.83h131.19c3.75,0,6.81,3.01,6.85,6.76.21,16.81.67,59.94-.09,71.18-.87,12.82-.15,242.72-.02,283.04.01,3.32-2.68,6.01-6,6.01h-101.93"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.83,
    y: 361.83,
    width: 321,
    height: 386
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 29.33,
    y: 361.33,
    width: 336,
    height: 49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m325.34,394.43c-.3,0-.54-.07-.74-.21s-.31-.32-.33-.54.05-.44.23-.66l5.9-7.04v.79l-5.56-6.67c-.2-.25-.28-.48-.26-.7.02-.22.13-.4.32-.54.19-.14.42-.21.7-.21.25,0,.46.05.65.14.19.1.37.27.55.52l4.92,5.99h-.71l4.87-5.99c.18-.25.36-.42.55-.52.19-.09.41-.14.68-.14.3,0,.54.07.73.21.19.14.29.32.32.54.02.22-.07.45-.28.7l-5.56,6.67v-.79l5.88,7.04c.18.22.26.44.25.66-.02.22-.12.4-.32.54s-.45.21-.76.21c-.21,0-.42-.05-.61-.15s-.39-.27-.59-.5l-5.24-6.38h.86l-5.21,6.38c-.2.23-.39.4-.59.5s-.41.15-.64.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 314.83,
    y: 370.83,
    width: 31,
    height: 31,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 38.83,
    y: 361.83,
    width: 321,
    height: 386
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "spreadsheet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheet"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-24",
    x: 15.33,
    y: 72.33,
    width: 314,
    height: 230
  }), /*#__PURE__*/React.createElement("g", {
    id: "grid_lines",
    "data-name": "grid lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 141.89,
    y1: 85.83,
    x2: 141.89,
    y2: 319.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 73.67,
    y1: 72.69,
    x2: 73.67,
    y2: 306.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 207.67,
    y1: 77.69,
    x2: 207.67,
    y2: 311.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 268.67,
    y1: 72.69,
    x2: 268.67,
    y2: 306.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 14.83,
    y1: 126.33,
    x2: 329.83,
    y2: 126.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 144.83,
    x2: 330.33,
    y2: 144.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 165.83,
    x2: 330.33,
    y2: 165.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 185.83,
    x2: 330.33,
    y2: 185.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 14.33,
    y1: 205.83,
    x2: 329.33,
    y2: 205.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 225.83,
    x2: 330.33,
    y2: 225.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 243.83,
    x2: 330.33,
    y2: 243.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 14.33,
    y1: 261.83,
    x2: 329.33,
    y2: 261.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.33,
    y1: 281.83,
    x2: 330.33,
    y2: 281.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 10.33,
    y: 283.33,
    width: 324,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 5.33,
    y: 52.33,
    width: 334,
    height: 58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.83,
    cy: 91.83,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.83,
    cy: 91.83,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.83,
    cy: 91.83,
    r: 5.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 14.83,
    y: 72.83,
    width: 315,
    height: 230
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "bar_chart",
    "data-name": "bar chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar_chart-2",
    "data-name": "bar chart"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 832.83,
    y: 700.83,
    width: 195,
    height: 94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 852.33,
    y: 760.33,
    width: 17,
    height: 75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 886.33,
    y: 735.33,
    width: 17,
    height: 75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 922.33,
    y: 719.33,
    width: 17,
    height: 75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 958.33,
    y: 762.33,
    width: 17,
    height: 75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 991.33,
    y: 727.33,
    width: 17,
    height: 75
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 832.83,
    y: 700.83,
    width: 195,
    height: 94
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "bullet_list",
    "data-name": "bullet list"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 835.83,
    y: 445.83,
    width: 160,
    height: 219
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 858.33,
    cy: 492.33,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 858.33,
    cy: 559.33,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 858.33,
    cy: 622.33,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 874.33,
    y1: 493.33,
    x2: 967.64,
    y2: 493.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 886.33,
    y1: 525.33,
    x2: 979.33,
    y2: 525.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 874.33,
    y1: 559.33,
    x2: 975.33,
    y2: 559.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 886.33,
    y1: 590.33,
    x2: 959.33,
    y2: 590.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 874.33,
    y1: 622.33,
    x2: 969.56,
    y2: 622.33
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "yellow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.83,
    y: 471.83,
    width: 189,
    height: 370
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 576.33,
    y: 470.33,
    width: 217,
    height: 61
  }), /*#__PURE__*/React.createElement("g", {
    id: "grey_lines",
    "data-name": "grey lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 563.79,
    x2: 774.33,
    y2: 563.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 590.33,
    x2: 774.33,
    y2: 590.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 774.33,
    y1: 550.97,
    x2: 706.33,
    y2: 550.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 577.51,
    x2: 774.33,
    y2: 577.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 626.79,
    x2: 774.33,
    y2: 626.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 653.33,
    x2: 774.33,
    y2: 653.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 613.97,
    x2: 774.33,
    y2: 613.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 706.33,
    y1: 640.51,
    x2: 774.33,
    y2: 640.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 626.79,
    x2: 691.33,
    y2: 626.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 653.33,
    x2: 691.33,
    y2: 653.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 613.97,
    x2: 691.33,
    y2: 613.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 640.51,
    x2: 691.33,
    y2: 640.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 643.33,
    y1: 700.79,
    x2: 691.33,
    y2: 700.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 643.33,
    y1: 687.97,
    x2: 679.33,
    y2: 687.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 643.33,
    y1: 714.51,
    x2: 688.33,
    y2: 714.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 563.79,
    x2: 691.33,
    y2: 563.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 590.33,
    x2: 691.33,
    y2: 590.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 550.97,
    x2: 691.33,
    y2: 550.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 623.33,
    y1: 577.51,
    x2: 691.33,
    y2: 577.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 714.83,
    y: 679.83,
    width: 50,
    height: 43,
    rx: 1.57,
    ry: 1.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 633.33,
    y1: 749.83,
    x2: 762.33,
    y2: 749.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 633.33,
    y1: 769.83,
    x2: 762.33,
    y2: 769.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 634.33,
    y1: 789.83,
    x2: 763.33,
    y2: 789.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 634.33,
    y1: 809.83,
    x2: 763.33,
    y2: 809.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 634.83,
    cy: 687.83,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 634.83,
    cy: 700.83,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 634.83,
    cy: 714.83,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 750.83,
    y: 486.83,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 756.33,
    y1: 500.81,
    x2: 773.33,
    y2: 500.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 756.33,
    y1: 507.81,
    x2: 773.33,
    y2: 507.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 756.33,
    y1: 493.83,
    x2: 773.33,
    y2: 493.83
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 603.83,
    y: 471.83,
    width: 189,
    height: 370
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "charts"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 590.83,
    y: 57.83,
    width: 404,
    height: 355
  }), /*#__PURE__*/React.createElement("g", {
    id: "butterfly"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 620.33,
    y: 162.83,
    width: 94,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 643.33,
    y: 189.24,
    width: 73,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 681.33,
    y: 240.06,
    width: 34,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 675.33,
    y: 265.47,
    width: 41,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 652.33,
    y: 290.87,
    width: 64,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 634.33,
    y: 316.28,
    width: 82,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 622.33,
    y: 341.69,
    width: 94,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 667.33,
    y: 214.65,
    width: 48,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 716.33,
    y: 162.83,
    width: 102,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 717.33,
    y: 189.24,
    width: 82,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 717.33,
    y: 240.06,
    width: 55,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 718.33,
    y: 265.47,
    width: 25,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 718.33,
    y: 290.87,
    width: 47,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 718.33,
    y: 316.28,
    width: 63,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 718.33,
    y: 341.69,
    width: 81,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 605.33,
    y: 366.69,
    width: 112,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 719.33,
    y: 366.69,
    width: 117,
    height: 14.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 717.33,
    y: 214.65,
    width: 78,
    height: 14.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 874.33,
    cy: 323.33,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 874.33,
    cy: 361.33,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 895.33,
    y1: 323.33,
    x2: 969.67,
    y2: 323.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 895.33,
    y1: 361.33,
    x2: 953.33,
    y2: 361.76
  })), /*#__PURE__*/React.createElement("g", {
    id: "bar_chart-3",
    "data-name": "bar chart"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 628.33,
    y: 117.33,
    width: 72,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 700.33,
    y: 117.33,
    width: 72,
    height: 22
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 628.33,
    y: 116.83,
    width: 176.5,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 628.33,
    y: 85.33,
    width: 109,
    height: 22
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 628.33,
    y: 84.83,
    width: 176.5,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", {
    id: "R-2",
    "data-name": "R"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 847.33,
    y: 101.83,
    width: 111.5,
    height: 172,
    rx: 4.72,
    ry: 4.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m945.89,116.42c-.14,0-.26-.04-.36-.11-.1-.08-.15-.17-.16-.29-.01-.12.03-.24.11-.36l2.88-3.85v.43l-2.71-3.65c-.1-.14-.14-.26-.13-.38.01-.12.06-.22.16-.29.09-.08.21-.11.34-.11.12,0,.23.03.32.08.09.05.18.15.27.28l2.4,3.28h-.35l2.38-3.28c.09-.14.18-.23.27-.28.09-.05.2-.08.33-.08.14,0,.26.04.35.11.09.08.14.17.16.29.01.12-.03.25-.14.38l-2.71,3.65v-.43l2.87,3.85c.09.12.13.24.12.36,0,.12-.06.22-.16.29-.1.08-.22.11-.37.11-.1,0-.2-.03-.3-.08-.1-.06-.19-.15-.29-.28l-2.56-3.49h.42l-2.54,3.49c-.1.13-.19.22-.29.28-.1.06-.2.08-.31.08Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 868.83,
    y1: 127.83,
    x2: 922.56,
    y2: 127.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 868.83,
    y1: 139.83,
    x2: 938.33,
    y2: 139.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 868.83,
    y1: 151.83,
    x2: 929.19,
    y2: 151.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 889.83,
    y1: 169.83,
    x2: 947.33,
    y2: 169.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 889.83,
    y1: 180.83,
    x2: 935.33,
    y2: 180.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 889.83,
    y1: 193.83,
    x2: 942.22,
    y2: 193.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 889.83,
    y1: 206.83,
    x2: 933.33,
    y2: 206.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 862.33,
    y1: 221.83,
    x2: 894.61,
    y2: 221.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 915.06,
    y1: 221.83,
    x2: 947.33,
    y2: 221.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 862.33,
    y1: 232.83,
    x2: 894.61,
    y2: 232.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 871.33,
    y1: 246.83,
    x2: 944.72,
    y2: 246.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 865.33,
    y1: 259.83,
    x2: 950.72,
    y2: 259.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 915.06,
    y1: 232.83,
    x2: 947.33,
    y2: 232.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 858.33,
    y: 170.33,
    width: 20,
    height: 37,
    rx: 1.67,
    ry: 1.67
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.3,
    y1: 506.39,
    x2: 270.7,
    y2: 506.39
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.67,
    y1: 534.39,
    x2: 254.33,
    y2: 534.39
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 157.67,
    y1: 563.39,
    x2: 240.33,
    y2: 563.39
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.83,
    y: 624.83,
    width: 150,
    height: 49,
    rx: 3.33,
    ry: 3.33
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrate);
export default __webpack_public_path__ + "static/media/integrate.528f32a88127e85eb1705d58749f3963.svg";
export { ForwardRef as ReactComponent };